// extracted by css-extract-rspack-plugin
export default {"title":"_b05bd8a3"};